

// import { useEffect } from "react";

// const GoogleTranslate = () => {
//   useEffect(() => {
//     const setCookie = () => {
//       document.cookie = "googtrans=/te/te; path=/;";
//       document.cookie =
//         "googtrans=/te/te; path=/; domain=" + window.location.hostname;
//     };

//     setCookie();

//     const replaceSelectLanguageText = () => {
//       const gadget = document.querySelector(".goog-te-gadget-simple");

//       if (!gadget) return;

//       // IMPORTANT: target ONLY inner span inside anchor
//       const textSpan = gadget.querySelector("a span");

//       if (textSpan) {
//         if (
//           textSpan.innerText.includes("Select Language") ||
//           textSpan.innerText.trim() === ""
//         ) {
//           textSpan.innerText = "Telugu";
//         }
//       }
//     };

//     window.googleTranslateElementInit = () => {
//       if (window.google?.translate) {
//         new window.google.translate.TranslateElement(
//           {
//             pageLanguage: "te",
//             includedLanguages: "te,en,hi,ta,ml,kn",
//             autoDisplay: false,
//             layout:
//               window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//           },
//           "google_translate_element"
//         );
//       }

//       // run multiple times (Google renders async)
//       setTimeout(replaceSelectLanguageText, 300);
//       setTimeout(replaceSelectLanguageText, 700);
//       setTimeout(replaceSelectLanguageText, 1200);

//       // keep sync after user change
//       setTimeout(() => {
//         const combo = document.querySelector(".goog-te-combo");

//         if (combo) {
//           combo.value = "te";
//           combo.addEventListener("change", replaceSelectLanguageText);
//         }
//       }, 1000);
//     };

//     if (!document.getElementById("google-translate-script")) {
//       const script = document.createElement("script");
//       script.id = "google-translate-script";
//       script.src =
//         "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//       script.async = true;
//       document.body.appendChild(script);
//     }
//   }, []);

//   return (
//     <div className="translate-wrapper notranslate" translate="no">
//       <div id="google_translate_element"></div>
//     </div>
//   );
// };

// export default GoogleTranslate;
import { useEffect } from "react";

const GoogleTranslate = () => {
  useEffect(() => {
    const setCookie = () => {
      document.cookie = "googtrans=/te/te; path=/;";
      document.cookie =
        "googtrans=/te/te; path=/; domain=" + window.location.hostname;
    };

    setCookie();

    const replaceSelectLanguageText = () => {
      const gadget = document.querySelector(".goog-te-gadget-simple");

      if (!gadget) return;

      const textSpan = gadget.querySelector("a span");

      if (!textSpan) return;

      const combo = document.querySelector(".goog-te-combo");

      let languageText = "Telugu";

      if (combo && combo.selectedIndex >= 0) {
        languageText =
          combo.options[combo.selectedIndex]?.text || "Telugu";
      }

      if (textSpan.innerText !== languageText) {
        textSpan.innerText = languageText;
      }
    };

    window.googleTranslateElementInit = () => {
      if (window.google?.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "te",
            includedLanguages: "te,en,hi,ta,ml,kn",
            autoDisplay: false,
            layout:
              window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          "google_translate_element"
        );
      }

      setTimeout(replaceSelectLanguageText, 500);
      setTimeout(replaceSelectLanguageText, 1500);
      setTimeout(replaceSelectLanguageText, 2500);

      setTimeout(() => {
        const combo = document.querySelector(".goog-te-combo");

        if (combo) {
          combo.addEventListener("change", () => {
            setTimeout(replaceSelectLanguageText, 300);
            setTimeout(replaceSelectLanguageText, 1000);
            setTimeout(replaceSelectLanguageText, 2000);
          });
        }
      }, 1000);
    };

    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="translate-wrapper notranslate" translate="no">
      <div id="google_translate_element"></div>
    </div>
  );
};

export default GoogleTranslate;